module.exports = __webpack_public_path__ + "static/guide_vaeg_til_vaeg.min-5d92c62bdd59c2c5293585be75c0d0a4.png";